/**
 * Barren Hint Row — location autocomplete with red styling.
 * Click on selected location to clear it.
 */
import { useTracker, type LocationDto as ContextLocationDto } from '@/contexts/tracker-context';
import { LocationAutocomplete } from './location-autocomplete';
import type { LocationDto } from '@/queries/types';

interface BarrenRowProps {
  id: number;
}

export function BarrenRow({ id }: BarrenRowProps) {
  const { state, dispatch } = useTracker();
  const current = state.barren[id] ?? null;

  const handleChange = (loc: LocationDto | null) => {
    const newBarren = [...state.barren];
    // Ensure array is big enough
    while (newBarren.length <= id) newBarren.push(null as unknown as ContextLocationDto);
    newBarren[id] = loc
      ? ({ id: loc.id, name: loc.name, areaId: loc.areaId, areaName: loc.areaName, tags: [] } as ContextLocationDto)
      : (null as unknown as ContextLocationDto);
    dispatch({ type: 'SET_BARREN', barren: newBarren });
  };

  const locationValue = current
    ? ({
        id: current.id,
        name: current.name,
        areaName: current.areaName,
      } as LocationDto)
    : null;

  return (
    <div className="flex items-center">
      <LocationAutocomplete
        label="Barren"
        value={locationValue}
        onChange={handleChange}
        width="w-full"
        className={current ? '' : 'bg-red-950/30 border-red-900/20 rounded'}
      />
    </div>
  );
}
